import {FormConfig} from '../../../models/form-config';
import {FieldType} from '../../../models/field-type';
import {Validator} from '../../../models/validator.enum';
import {AdditionalDataSectionConsts} from './additional-data-section.consts';
import {RegExpKey, RegExpService} from '../../../services/reg-exp.service';
import {TestingPresetsService} from '../../../services/debugging/testing-presets.service';
import {TestingPresetKey} from '../../../../core/enums/debugging/testing-preset-key.enum';

export class AdditionalDataSectionConfig {

  private vinValidators = [
    {
      name: Validator.PATTERN,
      pattern: this.regExpService.getRegExp(RegExpKey.VIN)
    },
    {
      name: Validator.MAX_LENGTH,
      maxLength: 17
    },
    {
      name: Validator.MIN_LENGTH,
      minLength: 17
    }
  ];

  constructor(private regExpService: RegExpService) {
  }

  createConfig(): FormConfig {
    let formConfig = <FormConfig>{
      formKey: 'ADDITIONAL_INFORMATION_SECTION',
      fieldsConfig: [
        {
          fieldKey: AdditionalDataSectionConsts.VIN,
          caption: `ADDITIONAL_INFORMATION_SECTION.FORM_FIELDS.${AdditionalDataSectionConsts.VIN}`,
          type: FieldType.TextField,
          validators: TestingPresetsService.isPresetActive(TestingPresetKey.VIN_VALIDATION_DISABLED) ? [] : this.vinValidators,
          properties: {
            textTransform: {
              type: 'uppercase'
            },
          }
        },
      ]
    };

    return formConfig;
  }
}

